import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    spacingContainer: {
      [breakpoints.down('md')]: {
        padding: '0px 8px 0px 9px',
      },
      [breakpoints.down(281)]: {
        padding: '0px 8px 85px 8px',
      },

      '& .grecaptcha-badge': {
        visibility: 'visible',
      },
    },
    forgotPasswordContainer: { marginBottom: 12, padding: '0 35px' },
    descriptionButtonsContainer: { marginTop: 5 },
    login: {
      marginBottom: 8,
      '& b': {
        fontWeight: 'bold',
      },
    },
    subtitleLogin: { marginBottom: 32, fontSize: 14 },
    copyrightWrapper: { marginTop: 46 },
    forgotPasswordLinkContainer: { textAlign: 'right', marginTop: 12 },
    checkboxLabel: {
      fontSize: 14,
      letterSpacing: 0,
      lineHeight: 0.25,
      color: palette.gray,
    },
    loginGrid: {
      [breakpoints.down(960)]: {
        marginTop: 20,
      },
      '& .MuiOutlinedInput-root': {
        height: 45,
        width: 340,
        borderColor: `${palette.darkGray} !important`,

        [breakpoints.down('md')]: {
          width: 300,
        },
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },

      '& .MuiOutlinedInput-root:not': {
        borderColor: `${palette.white} !important`,
      },

      '& .MuiOutlinedInput-input:-webkit-autofill': {
        fontSize: 12,
        height: 45,
      },

      '& .makeStyles-loginGrid-134 .MuiInputLabel-outlined': {
        fontSize: 12,
      },

      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
      },
      '& .MuiFormControl-fullWidth': {
        width: 'auto',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        [breakpoints.down(960)]: {
          borderColor: `${palette.white} !important`,
        },
      },
      '& .MuiInputBase-root': {
        [breakpoints.down(960)]: {
          color: `${palette.white} !important`,
        },
      },
      '& .MuiFormLabel-root': {
        color: `${palette.darkGray} !important`,
        [breakpoints.down(960)]: {
          color: `${palette.white} !important`,
        },
      },
    },
    forgotPasswordLinkText: {
      fontSize: 12,
      fontWeight: 500,
    },
    loginButton: {
      backgroundColor: palette.deepBlue,
      color: palette.white,
      height: 45,
      fontSize: 12,
      width: '85%',
      [breakpoints.down(350)]: {
        width: '100%',
      },
      '&:hover': {
        backgroundColor: palette.deepBlue,
        color: palette.white,
      },
      '& .MuiCircularProgress-colorPrimary': {
        color: `${palette.offWhite} !important`,
      },
    },
    text: { fontSize: 35 },
  });
